import { useApolloClient } from '@apollo/client'
import React, { useState } from 'react'

import Modal from '@@components/modal'

import { SET_DEFAULT_REVISION_MUTATION } from './_queries'

export default function SetDefaultModal({ studyRevisionId, onDone }) {
  const [waiting, setWaiting] = useState(false)
  const client = useApolloClient()

  const onConfirm = async () => {
    setWaiting(true)

    await client.mutate({
      mutation: SET_DEFAULT_REVISION_MUTATION,
      variables: {
        input: {
          studyRevisionId,
        },
      },
    })

    onDone(true)
  }

  if (waiting) {
    return (
      <Modal>
        <div className="align-self-center card shadow">
          <div className="card-body">
            <div className="spinner-border" />
          </div>
        </div>
      </Modal>
    )
  }

  return (
    <Modal onClose={() => onDone()}>
      <div className="align-self-center card shadow">
        <div className="card-body">
          <p className="fs-5 my-2">Are you sure you want to set this revision as the default?</p>
        </div>
        <div className="card-footer d-flex">
          <button id="set_default_confirm" onClick={onConfirm} type="button" className="btn btn-primary me-1">
            Yes
          </button>
          <button type="button" onClick={() => onDone()} className="btn btn-outline-secondary ms-1">
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  )
}
